import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Disclaimer = styled.p`
  margin: 0;
  color: ${(props) => props.theme.newColors["gray-900"]};
  font-size: ${(props) => props.theme.fontSize.XXXS};
  line-height: 1.5;
  white-space: pre-line;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;

  button {
    white-space: nowrap;
  }

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    flex-direction: column;
    width: 100%;

    button {
      height: 2.5rem;
      width: 100%;
    }

    button:last-child {
      order: -1;
    }
  }
`;
